import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WizardComponent } from './wizard.component';
import { KWizardModule } from 'ng-k-wizard';
import { KTabsModule } from 'ng-k-tabs';
import { KButtonModule } from 'ng-k-button';
import { KIconModule } from 'ng-k-icon';
import { KNotificationsModule } from 'ng-k-notifications';
import { CustomBreadcrumbModule } from '../common/custom-breadcrumb/custom-breadcrumb.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpReqInterceptor } from 'src/app/interceptors/http-req.interceptor';
@NgModule({
  declarations: [
    WizardComponent
  ],
  imports: [
    CommonModule,
    KWizardModule,
    KTabsModule,
    KButtonModule,
    KNotificationsModule,
    KIconModule,
    CustomBreadcrumbModule
  ],
  exports: [
    KWizardModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpReqInterceptor,
      multi: true,
    },
  ]
})
export class WizardModule { }
